import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

// Material UI
import { withStyles } from 'material-ui/styles';

// Authentication
import { auth } from '../../../../../../../../config/constants/database';

// Styles
import styles from './styles';

class Content extends Component {
  render(){
    const { classes, location} = this.props;
    return(
      <div className={classes.root}>
        <Typography type="subheading" color="inherit" className={classes.text}>
          Text at: 816-555-1212
        </Typography>
        <br/>
        <Typography type="subheading" color="inherit" className={classes.text}>
          Voicemail at: 816-555-1212
        </Typography>
        <br/>
        <Typography type="subheading" color="inherit" className={classes.text}>
          Email to: lolo@DatingServiceNetwork.com
        </Typography>
        <br/>
      </div>
    );
  }
}

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        email: state.email.email,
        password: state.password.password,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Content)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Contact/components/CoreContent/components/Content/index.js